import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { LucideIconsModule } from '../../../shared/lucide-icons.module';
import { ActivatedRoute, Router, RouterLink, RouterOutlet, NavigationEnd } from '@angular/router';
import { UserService } from '../../../service/user.service';
import { TokenIdService } from '../../../service/token-id.service';
import { filter } from 'rxjs/operators';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-user-dashboard',
  imports: [CommonModule, LucideIconsModule, RouterLink, RouterOutlet, DialogModule],
  templateUrl: './user-dashboard.component.html',
  styleUrl: './user-dashboard.component.css'
})
export class UserDashboardComponent  implements OnInit{
  activeTab: string = 'overview';

  user: any;
  profileLoading = false;
  profileError = '';
  showLogoutConfirm = false;

  tabs = [
    { id: 'overview', label: 'Overview', icon: 'chart-column' },
    { id: 'portfolios', label: 'Portfolios', icon: 'chart-pie' },
  // Transactions tab: keep the lucide icon as fallback, also provide a path to the AED SVG
  { id: 'transactions', label: 'Transactions', icon: 'euro', iconPath: '/assets/images/icons/UAE_Dirham_Symbol.svg' },
    { id: 'wallet', label: 'Wallet', icon: 'wallet' },
    { id: 'analytics', label: 'Analytics', icon: 'activity' },
    { id: 'profile', label: 'Profile', icon: 'settings' }
  ];

  constructor(private router: Router, private route: ActivatedRoute, private userService: UserService, private tokenIdService: TokenIdService) {
  
  }
  ngOnInit(): void {
    // Set initial active tab based on current route
    this.setActiveTabFromRoute();
    
    // Handle route changes
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.setActiveTabFromRoute();
    });
    
    // Ensure a default child route on /user if no route is active
    if (!this.route.firstChild || this.route.firstChild.snapshot.url.length === 0) {
      this.router.navigate(['overview'], { relativeTo: this.route, replaceUrl: true });
    }
    
    this.fetchUserProfile();
  }
  
  private setActiveTabFromRoute(): void {
    let currentRoute = this.route;
    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }
    const path = currentRoute.snapshot.url[0]?.path;
    if (path && this.tabs.some(tab => tab.id === path)) {
      this.activeTab = path;
    } else {
      this.activeTab = 'overview';
    }
  }


  private fetchUserProfile(): void {
    this.profileLoading = true;
    this.profileError = '';
    const token = this.userService.getAuthToken();
    const userId = this.tokenIdService.getUserIdFromToken(token || '');
    if (!userId) {
      this.profileError = 'User not authenticated.';
      this.profileLoading = false;
      return;
    }
    this.userService.getProfile(userId).subscribe({
      next: (profile) => {
        this.user = profile;
        this.profileLoading = false;
      },
      error: (err) => {
        this.profileError = err?.message || 'Failed to load profile.';
        this.profileLoading = false;
      }
    });
  }

  setActiveTab(tabId: string): void {
    if (!this.tabs.some(t => t.id === tabId)) return;
    this.router.navigate([tabId], { relativeTo: this.route });
  }

  openLogoutDialog(): void {
    this.showLogoutConfirm = true;
  }

  cancelLogout(): void {
    this.showLogoutConfirm = false;
  }

  onLogout(): void {
    // Confirmed logout
    localStorage.clear();
    this.showLogoutConfirm = false;
    this.router.navigate(['/']);
  }
}
